import React, { Component } from 'react'


export default function FullContainerBack(props:any){

    return(<div className="container container-back">
        {props.children}
    </div>);
}